import { type CoreProduct } from '@flecto/types'

/**
 * Returns a slug based on a given product.
 *
 * @param product - The product to generate a slug from.
 * @returns The slug.
 *
 * @example
 * useProductSlugEncode({ id: '123', title: 'Hello World' });
 * // returns 123-hello-world
 *
 * @example
 * useProductSlugEncode({ id: '123', title: 'Hello [1] World' });
 * // returns 123-hello-1-world
 *
 * @example
 * useProductSlugEncode({ id: '123', title: 'Teste' });
 * // returns 123-teste
 */

export function useProductSlugEncode(product?: CoreProduct) {
  if (!product) return ''

  const text = product.title || ''
  const id = product.id || ''

  const normalized = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[àáâãäå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[ñ]/g, 'n')

  const slug = normalized
    .toLowerCase()
    .replace(/\[(\d+)\]/g, '$1-')
    .replace(/[\s_-]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')

  return id && slug ? `${id}-${slug}` : id ? id : slug
}
